import { CREATE_PROYECTS, GET_PROYECTS, UPDAT_EPROYECTS, DELETE_PROYECTS } from '../Action-types';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api/proyect`;

export const getProjects = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL);
    dispatch({
      type: GET_PROYECTS,
      payload: response.data.projects,
    });
  } catch (error) {
    console.error('Error al obtener proyectos:', error);
  }
};

export const createProject = (projectData) => async (dispatch) => {
  try {
    const response = await axios.post(API_URL, projectData);
    dispatch({
      type: CREATE_PROYECTS,
      payload: response.data.project,
    });
  } catch (error) {
    console.error('Error al crear proyecto:', error);
  }
};

export const updateProject = (id, projectData) => async (dispatch) => {
  try {
    console.log('Proyect data action: ', projectData);

    const response = await axios.put(`${API_URL}/update/${id}`, projectData);
    dispatch({
      type: UPDAT_EPROYECTS,
      payload: response.data.project,
    });
  } catch (error) {
    console.error('Error al actualizar proyecto:', error);
  }
};

export const deleteProject = (id) => async (dispatch) => {
  try {
    await axios.delete(`${API_URL}/delete/${id}`);
    dispatch({
      type: DELETE_PROYECTS,
      payload: id,
    });
  } catch (error) {
    console.error('Error al eliminar proyecto:', error);
  }
};
